/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

type FullWidthPageProps = PageProps;

export interface FullWidthPageStyles {
    page?: MobiusPageProps;
}

export const homePageStyles: FullWidthPageStyles = {
    page: {
        fullWidth: [true, true, true, true, true],
    },
};
const styles = homePageStyles;
const FullWidthPage: React.FC<FullWidthPageProps> = ({ id }) => {
    return (
        <Page {...styles.page}>
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const FullWidthPageModule: PageModule = {
    component: FullWidthPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
        fieldDefinitions: [
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            HideHeader,
            HorizontalRule,
            MetaDescription,
            MetaKeywords,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
        ] as any,
    },
};

export default FullWidthPageModule;

export const FullWidthPageContext = "FullWidthPage";
